import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import About from './About';
import Upload from './Upload';
import AI from './AI';
import Pin_Drop from './Pin_Drop'
import NavBar from '../components/NavBar'
import Upload_Image from './Upload_Image';
import '../styles/App.css';
import NotFound from './NotFound'; // <-- your 404 component

function App() {
  return (
    <Router>
      <div className = "p-5 bg-gray-900 text-gray-400 h-screen">
        <NavBar/>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/upload" element={<Upload />} />
          <Route path="/ai" element={<AI />} />
          <Route path="/pin_drop" element={<Pin_Drop />} />
          <Route path="/upload_image" element={<Upload_Image />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;